<div [class]="containerClasses">
  <div class="relative">
    <input
      #inputEl
      type="text"
      role="combobox"
      [attr.aria-label]="ariaLabel"
      [attr.aria-expanded]="open"
      aria-autocomplete="list"
      autocomplete="off"
      [class]="computedInputClasses"
      [class.pr-9]="clearable && (value || query)"
      [value]="query"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)" />

    @if (clearable && (value || query) && !disabled) {
      <button
        type="button"
        class="btn btn-ghost btn-xs btn-circle absolute right-1 top-1/2 -translate-y-1/2"
        tabindex="-1"
        aria-label="Clear"
        (mousedown)="onClear($event)">
        ✕
      </button>
    }
  </div>

  @if (open && !disabled) {
    <ul
      class="absolute left-0 right-0 z-50 mt-1 flex flex-col bg-base-100 rounded-box border border-base-300 shadow-lg max-h-72 overflow-y-auto py-1"
      role="listbox">
      @if (filteredOptions.length === 0) {
        <li class="px-3 py-2 text-sm text-base-content/60">{{ emptyMessage }}</li>
      } @else {
        @for (opt of filteredOptions; track trackByValue($index, opt); let i = $index) {
          <li class="block">
            <button
              type="button"
              role="option"
              [attr.aria-selected]="opt.value === value"
              class="flex w-full items-center justify-between gap-2 px-3 py-2 text-left hover:bg-base-200 focus:bg-base-200 focus:outline-none"
              [class.bg-base-200]="i === highlightIndex"
              [class.font-medium]="opt.value === value"
              (mousedown)="selectOption(opt)"
              (mouseenter)="highlightIndex = i">
              <span class="truncate">{{ opt.label }}</span>
              @if (opt.value === value) {
                <span class="text-primary text-xs shrink-0">✓</span>
              }
            </button>
          </li>
        }
      }
    </ul>
  }
</div>


